const NAME_UTIL = "KibernetesSharing";

export default class KibernetesSharing {
  #conf;

  constructor() {
    this.#conf = {
      "facebook": (page,title) => { return `https://www.facebook.com/sharer.php?u=${page}&t=${title}`},
      "twitter": (page,title) => { return `https://twitter.com/share?url=${page}&text=${title}`},
      "linkedin": (page,title) => { return `https://www.linkedin.com/shareArticle?mini=true&url=${page}&title=${title}&ro=false&summary=&source=`},
      "whatsapp": (page,title) => { return `https://api.whatsapp.com/send?text=${page}`},
      "telegram": (page,title) => { return `https://t.me/share/url?url=${page}&text=${title}`}
    }
  }
  #evaluateGeneric(vals, fn){
       return fn.apply(null, vals);
  }
  share( page, title, service ) {
    let url = this.#conf[service](encodeURIComponent(page), encodeURIComponent(title));
    window.open( url, "sharing" );
  }
}
